var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHouseholdliving({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-household_living",
    "data-name": "ic-household&living",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39705",
    "data-name": "Path 39705",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39707",
    "data-name": "Path 39707",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "chair_FILL1_wght400_GRAD0_opsz48",
    d: "M6.426,26.859a.841.841,0,0,1-.868-.868V24.747h-.55a2.786,2.786,0,0,1-2.155-.94A3.222,3.222,0,0,1,2,21.564v-7a2.221,2.221,0,0,1,.593-1.548,1.9,1.9,0,0,1,1.461-.651,1.9,1.9,0,0,1,1.461.651,2.22,2.22,0,0,1,.593,1.548v5H23.35v-5a2.221,2.221,0,0,1,.593-1.548,1.965,1.965,0,0,1,2.922,0,2.221,2.221,0,0,1,.593,1.548v7a3.222,3.222,0,0,1-.853,2.242,2.754,2.754,0,0,1-2.126.94H23.9v1.244a.868.868,0,1,1-1.736,0V24.747H7.294v1.244a.841.841,0,0,1-.868.868Zm1.418-9.026V14.563a4.18,4.18,0,0,0-.767-2.474,3.336,3.336,0,0,0-2.069-1.374V8.98a3,3,0,0,1,.81-2.1A2.635,2.635,0,0,1,7.844,6H21.615a2.68,2.68,0,0,1,2.04.882,2.968,2.968,0,0,1,.825,2.1v1.736a3.519,3.519,0,0,0-2.083,1.4,4.082,4.082,0,0,0-.781,2.445v3.269Z",
    transform: "translate(11.178 9.764)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHouseholdliving);
export default __webpack_public_path__ + "static/media/ic-household&living.4766f15a47d21fde0c036fe26f85fda0.svg";
export { ForwardRef as ReactComponent };